import React, { useState } from 'react';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { Helpers } from '../../../../helpers/Helpers';
import { GetAntrepoByIdResponseAntrepoArea } from '../../../../models/response/antrepo/GetAntrepoByIdResponse';
import { toast } from "react-hot-toast";
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import { ConstantService } from '../../../../services/ConstantService';
import CustomSwitch from '../../../../components/CustomSwitch';
import Box from '../../../../components/Box';
import { storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';
import { useDispatch } from 'react-redux';

interface Props {
    antrepoAreas: GetAntrepoByIdResponseAntrepoArea[]
    areaRef: any
    setAntrepoAreas: React.Dispatch<React.SetStateAction<GetAntrepoByIdResponseAntrepoArea[]>>
}

const AreaInformation = ({ antrepoAreas, areaRef, setAntrepoAreas }: Props) => {
    const dispatch = useDispatch();
    const [antrepoAreaId, setAntrepoAreaId] = useState<string | undefined>(undefined);
    const [name, setName] = useState<string | undefined>('');
    const [isOpen, setIsOpen] = useState(false);
    const [selectedAntrepoAreaType, setSelectedAntrepoAreaType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState<boolean | undefined>(true);

    const setUpdateItem = () => {
        var o = antrepoAreas.filter(x => x.isSelected)[0];

        setAntrepoAreaId(o.antrepoAreaId);
        setName(o.name);
        setSelectedAntrepoAreaType(o.antrepoAreaTypeId && o.antrepoAreaTypeName ? { label: o.antrepoAreaTypeName, value: o.antrepoAreaTypeId } : undefined);
        setIsCustomActive(o.isCustomActive);
        setIsOpen(true);
        scrollTo();
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setAntrepoAreaId('');
        setName('');
        setSelectedAntrepoAreaType(undefined);
        setIsCustomActive(true);
        setIsOpen(false);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = areaRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const deleteItems = () => {
        setAntrepoAreas(antrepoAreas.filter(x => !x.isSelected));
    }

    const selectAll = () => {
        var isAllSelected = antrepoAreas.length == antrepoAreas.filter(x => x.isSelected).length;

        setAntrepoAreas(antrepoAreas.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const setItemSelected = (_id: string) => {
        setAntrepoAreas(antrepoAreas.map(function (x) {
            if (x.antrepoAreaId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const saveItem = () => {
        if (Helpers.isEmpty(name))
            toast.error('Alan Adı alanını doldurunuz!')
        else if (!selectedAntrepoAreaType)
            toast.error('Alan Türü alanını doldurunuz!')
        else {
            if (Helpers.isEmpty(antrepoAreaId)) {
                var o: GetAntrepoByIdResponseAntrepoArea = {
                    antrepoAreaId: Helpers.generateUUID(),
                    isSelected: false,
                    antrepoAreaTypeId: selectedAntrepoAreaType?.value,
                    antrepoAreaTypeName: selectedAntrepoAreaType?.label,
                    isCustomActive: isCustomActive,
                    name: name
                }

                setAntrepoAreas([...antrepoAreas, o])
            }
            else {
                setAntrepoAreas(antrepoAreas.map(function (x) {
                    if (x.antrepoAreaId == antrepoAreaId) {
                        x.isSelected = false;
                        x.antrepoAreaTypeId = selectedAntrepoAreaType?.value;
                        x.antrepoAreaTypeName = selectedAntrepoAreaType?.label;
                        x.isCustomActive = isCustomActive;
                        x.name = name;
                    }

                    return x;
                }))
            }

            setAntrepoAreaId('');
            setName('');
            setSelectedAntrepoAreaType(undefined);
            setIsCustomActive(true);
            setIsOpen(false);
            scrollTo();
        }
    }

    return (
        <div className='containerPart' ref={areaRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Antrepo Alan Bilgileri</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Alan Adı</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Alan Türü</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedAntrepoAreaType}
                                            onChange={setSelectedAntrepoAreaType}
                                            onMenuOpen={() => ConstantService.getConstantList('ANTREPO_AREA_TYPE', undefined, undefined)}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>

                                        <CustomSwitch isActive={isCustomActive} setIsActive={setIsCustomActive} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={antrepoAreas.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={antrepoAreas.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>

                        <Box onClick={antrepoAreas.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={antrepoAreas.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>

                        <Box onClick={antrepoAreas.filter(x => x.isSelected).length > 0 ? () => alert('NOT IMPLEMENTED YET') : undefined} opacity={antrepoAreas.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2" bg='orange' justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-barcode" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Barkod</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={antrepoAreas.filter(x => x.isSelected).length > 0 && antrepoAreas.filter(x => x.isSelected).length == antrepoAreas.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Alan Adı</th>
                                            <th>Alan Türü</th>
                                            <th>Aktif</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            antrepoAreas.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            antrepoAreas.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input onChange={() => setItemSelected(item.antrepoAreaId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.name}</td>
                                                    <td>{item.antrepoAreaTypeName}</td>
                                                    <td>{item.isCustomActive ? <i style={{ fontSize: 20 }} className="text-success fa fa-check-circle" /> : <i style={{ fontSize: 20 }} className="text-danger fa fa-times-circle" />}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default AreaInformation;